// Support: a link to the Wizard Poker Discord (help, bug reports). Inside the
// Discord Activity a plain link cannot leave the iframe, so it goes through
// the Embedded App SDK's openExternalLink when the SDK is loaded.
import type { MouseEvent } from "react";
import { IN_DISCORD } from "../../discord/activity";
import { Icon } from "./Icon";

export const DISCORD_INVITE_URL = "https://discord.gg/Uf3XFJkAD4";

function openInvite(ev: MouseEvent<HTMLAnchorElement>): void {
  if (!IN_DISCORD) return;
  ev.preventDefault();
  void import("../../discord/discordSdk")
    .then((m) => m.openExternalLink(DISCORD_INVITE_URL))
    .then((opened) => {
      if (!opened) window.open(DISCORD_INVITE_URL, "_blank", "noopener,noreferrer");
    });
}

export function SupportPanel({ testId = "support-panel" }: { testId?: string }) {
  return (
    <div className="support-panel" data-testid={testId}>
      <Icon name="chat" size={36} />
      <p className="support-title">Support</p>
      <p className="muted">Need help or found a bug? Join our Discord.</p>
      <a className="btn primary" href={DISCORD_INVITE_URL} target="_blank" rel="noopener noreferrer" onClick={openInvite} data-testid="support-discord-link">
        Join the Discord
      </a>
    </div>
  );
}
